// src/store/modules/regionalPartner.js
import axios from "axios";

export default {
  actions: {
    GET_PARTNER_PROFILE: async () => {
      const response = await axios.get("/RegionalPartner/GetProfile");
      return response.data;
    },
    GET_PARTNER_REFERALS: async () => {
      const response = await axios.get("/RegionalPartner/GetReferals");
      return response.data;
    },
    GET_PARTNER_PAYOUTS: async () => {
      const response = await axios.get("/RegionalPartner/GetPayoutRequests");
      return response.data;
    },
    CREATE_PAYOUT_REQUEST: async () => {
      const response = await axios.post("/RegionalPartner/CreatePayoutRequest");
      return response.data;
    },
    GET_REFERAL_INFO_BY_USER: async (_, userId) => {
      const response = await axios.get(`/RegionalPartner/GetReferalInfoByUser?userId=${userId}`);
      return response.data;
    },
    GET_ALL_PARTNER_REFERALS: async () => {
      const response = await axios.get("/RegionalPartner/GetAllReferals");
      return response.data;
    },
    GET_ALL_PAYOUT_REQUESTS: async () => {
      const response = await axios.get("/RegionalPartner/GetAllPayoutRequests");
      return response.data;
    },
    SET_PAYOUT_STATUS: async (_, { requestId, status, comment }) => {
      return axios.put("/RegionalPartner/SetPayoutStatus", { requestId, status, comment });
    },
  },
};
